import { arjTimelineEmbedRouteEntry } from './timeline';

export const arjEmbedRouteEntries = [arjTimelineEmbedRouteEntry];
